/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */
import { useState, useEffect } from 'react';
import { fetchTokenPaths } from 'data-token-views/api/dataTokens';
const UNSET = undefined;
export default function (paths, config) {
  const [cache, setCache] = useState({});

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    let isSubscribed = true;
    const pathsToFetch = paths.filter(path => {
      return cache[path] === UNSET || cache[path].resolvable === false;
    });
    if (pathsToFetch.length > 0) {
      fetchTokenPaths(pathsToFetch, config).then(pathsMap => {
        if (isSubscribed) {
          setCache(prevCache => {
            return Object.assign({}, prevCache, pathsMap);
          });
        }
      });
    }
    return () => {
      isSubscribed = false;
      return;
    };
  }, [config, paths]);
  return cache;
}